import {
	loggerLink,
	splitLink,
	unstable_httpSubscriptionLink,
} from "@trpc/client";
import superjson from "superjson"; // noinspection JSUnusedGlobalSymbols
import { createTRPCNuxtClient, httpBatchLink } from "trpc-nuxt/client";
import type { AppRouter } from "~/server/trpc/root";

// noinspection JSUnusedGlobalSymbols
export default defineNuxtPlugin(() => {
	const headers = useRequestHeaders();

	/**
	 * createTRPCNuxtClient adds a `useQuery` composable
	 * built on top of `useAsyncData`.
	 */
	const client = createTRPCNuxtClient<AppRouter>({
		links: [
			loggerLink(),
			splitLink({
				condition: (op) => op.type === "subscription",
				true: unstable_httpSubscriptionLink({
					transformer: superjson,
					url: "/api/trpc",
				}),
				false: httpBatchLink({
					transformer: superjson,
					url: "/api/trpc",
					maxURLLength: 2083,
					headers() {
						return { ...headers };
					},
				}),
			}),
		],
	});

	return {
		provide: {
			client,
		},
	};
});

export type client = ReturnType<typeof createTRPCNuxtClient<AppRouter>>;
